import React, { useEffect, useState, useContext, Fragment, useCallback } from 'react';
import Accordion from 'b2b-ui-components-lib/lib/components/accordion';
import Select from 'b2b-ui-components-lib/lib/components/select';
import RadioGroup from 'b2b-ui-components-lib/lib/components/radioGroup';
import Input from 'b2b-ui-components-lib/lib/components/input';
import Checkbox from 'b2b-ui-components-lib/lib/components/checkbox';
import Button from 'b2b-ui-components-lib/lib/components/button';
import KnowMorePopup from 'home/view/upgrade-order/components/common/KnowMorePopup';
import DedicatedAccordionComponent from 'home/view/check-feasibility/component/dedicatedaccordion';
import CustomModal from 'home/view/upgrade-order/components/common/CustomModal';

import { getPricingAsync, getCpeAsync, getNonStandardCpeAsync } from 'home/view/upgrade-order/services';

import { CONTEXT } from 'home/view/upgrade-order/context';

import { TOAST_TYPE, LEAD_STATUS, CUSTOMER_ROLE, HARDWARE_TYPE, SERVICE_TYPE, FIELD_ERROR, USER_TYPE, SESSION_STORAGE, MEDIA_TYPES } from 'home/view/upgrade-order/constants';

import {
  getLeadStatus,
  getCustomerDetail,
  getServiceType,
  getMediaType,
  getLeadSegment,
  getProductName,
  getCurrentBw,
  getHardwareType,
  getCustomerContactList,
  getSiteIncharge,
  getFeasibilityResponse,
  getSpecs,
  getCpeSpecification,
  getOrderType,
  getSource,
  getErrMsg,
  emailValidator,
  mobileValidator,
  getOldLineItemDetail,
  getEligibleMediaType,
  setMediaOptions,
  splittedBwValue,
  isValidObject,
  fsCancelOrderOnClick
} from 'home/view/upgrade-order/utils';

import { getFromSessionStorage, setInSessionStorage } from 'common/utils/app.utils';

import dotGreen from 'assests/svg/dot-green.svg';
import dotWarn from 'assests/svg/dot-warn.svg';
import dotRed from 'assests/svg/dot-red.svg';
import alert_warn from 'assests/svg/alert_warn.svg';
import classNames from 'classnames';
import { ROUTERS, getProductType, isShiftingJourney } from 'common/constants/app.constants';
import { SINGLE_SITE } from 'home/view/manage-feasibility/constants';
import { DEDICATED_FEASIBILITY_DATA, MODULE_ID } from 'home/common/constants/constants';

const SERVICE_TYPE_LIST = [
  {
    key: SERVICE_TYPE.MANAGED,
    displayName: SERVICE_TYPE.MANAGED.toTitleCase()
  },
  {
    key: SERVICE_TYPE.UNMANAGED,
    displayName: SERVICE_TYPE.UNMANAGED.toTitleCase()
  },
  {
    key: SERVICE_TYPE.PARTIALLY_MANAGED,
    displayName: 'Partially Managed'
  }
];

const HARDWARE_TYPE_LIST = [
  {
    id: HARDWARE_TYPE.STANDARD,
    displayName: 'Standard Hardware'
  },
  {
    id: HARDWARE_TYPE.NON_STANDARD,
    displayName: 'Non-Standard Hardware (additional charges may apply) '
  }
];

const TitleComponent = React.memo(
  ({
    isExpanded,
    currentBw,
    serviceType,
    hardwareType,
    feasibilityStatus,
    media,
    leadStatus,
    createLead,
    blockJourney,
    bwAtMaxCircuit,
    eligibleMedia,
    selectedPrimaryMedia,
    showMediaTypeDropdown
  }) => {
    const isFeasibilityDone = (feasibilityStatus && Object.keys(feasibilityStatus).length > 0) || false;
    const hasSelectedMedia = selectedPrimaryMedia && Object.keys(selectedPrimaryMedia).length > 0;

    const isMediaOffnet = (Array.isArray(eligibleMedia) && eligibleMedia.some((item) => item.media === 'Offnet')) || false;

    const isMediaThirdParty = (Array.isArray(eligibleMedia) && eligibleMedia.some((item) => item.media === 'Third Party')) || false;

    const getServiceType = () => {
      if (serviceType === SERVICE_TYPE.PARTIALLY_MANAGED) {
        return 'Partially Managed';
      }

      return serviceType.toTitleCase();
    };

    const getFeasibilityStatusForTitle = () => {
      switch (leadStatus) {
        case LEAD_STATUS.FEASIBILITY_COMPLETED:
        case LEAD_STATUS.LEAD_SUBMITTED:
        case LEAD_STATUS.KYC_IN_PROGRESS:
        case LEAD_STATUS.REQUIRED_PRICE_NEGOTIATION:
        case LEAD_STATUS.PRICING_APPROVAL_REQUEST_SENT: {
          const maxFeasibleBw = hasSelectedMedia ? selectedPrimaryMedia.maxFeasibleBw : feasibilityStatus.maxBandwidth;
          return maxFeasibleBw ? (
            <li key={leadStatus}>
              <span>Feasibility Status:</span>
              <img src={dotGreen} alt="dot-green" style={{ margin: '0 5px' }} />
              <span>{`Feasible Upto ${maxFeasibleBw} Mbps`}</span>
            </li>
          ) : null;
        }
        case LEAD_STATUS.FEASIBILITY_PENDING: {
          return (
            <li key={leadStatus}>
              <span>Feasibility Status:</span>
              <img src={dotWarn} alt="dot-warn" style={{ margin: '0 5px' }} />
              <span>Under Manual Network Check</span>{' '}
            </li>
          );
        }
        case LEAD_STATUS.LOCATION_NOT_FEASIBLE: {
          return (
            <li key={leadStatus}>
              <span>Feasibility Status:</span>
              <img src={dotRed} alt="dot-red" style={{ margin: '0 5px' }} />
              <span>Not Feasible</span>
            </li>
          );
        }
        default: {
          return null;
        }
      }
    };

    const getMediaTitle = () => {
      if (showMediaTypeDropdown()) {
        if (hasSelectedMedia) {
          return <li key={selectedPrimaryMedia.key}>{`Media Type: ${selectedPrimaryMedia.key}`}</li>;
        }

        return <li key={media.value}>{`Media Type: ${media.value}`}</li>;
      }
    };

    return (
      <React.Fragment>
        {isExpanded ? (
          <div className="upgrade-header-open">
            {isShiftingJourney() ? (
              <Fragment>
                <div className="title pad-bottom-0">New Site Details</div>
                <label className="field_label">Please provide the new site details to get accurate network feasibility report.</label>
              </Fragment>
            ) : (
              <Fragment>
                <div className="title pad-bottom-0">Upgrade Details</div>
                <label className="field_label">The following the feasibility details for the upgrade order.</label>
              </Fragment>
            )}
          </div>
        ) : (
          <Fragment>
            <div className="upgrade-header-open">
              <div className="title pad-bottom-0">{isShiftingJourney() ? 'New Site Details' : 'Upgrade Details'}</div>
              <label className="field_label">
                {isShiftingJourney()
                  ? 'Please provide the new site details to get accurate network feasibility report.'
                  : 'The following the feasibility details for the upgrade order.'}
              </label>
            </div>
            <ul className="upgrade-header-closed" style={{ alignItems: 'center' }}>
              {getFeasibilityStatusForTitle()}
              {getMediaTitle()}
              {currentBw && <li key={currentBw}>{`Required Bandwidth: ${currentBw}`}</li>}
              {serviceType && <li key={serviceType}>{`Service Type: ${getServiceType()}`}</li>}
            </ul>
          </Fragment>
        )}
      </React.Fragment>
    );
  }
);

const UpgradeOrderDetailsAccordion = ({
  leadData = {},
  pnqFormOpen = false,
  setIsPnqFormOpen = () => {},
  createLead = () => {},
  errors = {},
  setErrors = () => {},
  submitClicked = false,
  contactList = [],
  setContactList = () => {},
  selectedContact = {},
  setSelectedContact = () => {},
  siteInCharge = {},
  setSiteInCharge = () => {},
  selectedBandwidth = {},
  setSelectedBandwidth = () => {},
  selectedServiceType = {},
  setSelectedServiceType = () => {},
  selectedCpe = {},
  setSelectedCpe = () => {},
  selectedCpeSpecification = {},
  setSelectedCpeSpecification = () => {},
  setSelectedHardwareType = () => {},
  blockJourney = false,
  setBlockJourney = () => {},
  selectedPrimaryMedia = {},
  setSelectedPrimaryMedia = () => {},
  loading = false,
  checkErrors = () => {},
  onSubmitClick = () => {},
  onCancelClick = () => {},
  isSubmitDisabled = () => {},
  isCancelDisabled = () => {},
  checkShiftingFeasibility = () => {},
  cancelPnQLead = () => {}
}) => {
  const savedFeasibilityData = getFromSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_DATA);
  const { setToastMsg, pnqToken, userType, isdedicatedJourney, isUnAuthJourney } = useContext(CONTEXT);

  const upgradeDetails = {
    leadStatus: getLeadStatus(leadData),
    customerDetail: getCustomerDetail(leadData),
    currentBw: getCurrentBw(leadData),
    serviceType: getServiceType(leadData),
    hardwareType: getHardwareType(leadData),
    customerContactList: getCustomerContactList(leadData),
    siteIncharge: getSiteIncharge(leadData) || {},
    feasibilityResponse: getFeasibilityResponse(leadData),
    media: getMediaType(leadData) || {},
    productName: getProductName(leadData),
    leadSegment: getLeadSegment(leadData),
    orderType: getOrderType(leadData),
    source: getSource(leadData),
    cpeDetails: getSpecs(leadData) || {},
    cpeSpecificationDetails: getCpeSpecification(leadData) || {},
    oldLineItemDetails: getOldLineItemDetail(leadData),
    eligibleMedia: getEligibleMediaType(leadData)
  };

  const [accordionMeta, setAccordionMeta] = useState({
    isExpanded: true
  });

  const [checked, setChecked] = useState(false);
  const [bandwidthList, setBandwidthList] = useState([]);
  const [defaultBwList, setDefaultBwList] = useState([]);
  const [bwAtMaxCircuit, setBwAtMaxCircuit] = useState(false);
  const [serviceTypeList, setServiceTypeList] = useState([]);
  const [selectedHardwareTypeLocal, setSelectedHardwareTypeLocal] = useState({});
  const [routerSpecsMasterList, setRouterSpecsMasterList] = useState([]); // different data set for standard and non-standard selection
  const [cpeList, setCpeList] = useState([]);
  const [cpeSpecificationList, setCpeSpecificationList] = useState([]);
  const [showKnowMorePopup, setShowKnowMorePopup] = useState(false);
  const [showMaxBwText, setShowMaxBwText] = useState(false);
  const [primaryMediaOptions, setPrimaryMediaOptions] = useState([]);
  const [defaultContactPhoneNumberValid, setDefaultContactPhoneNumberValid] = useState(false);
  const [formTouched, setFormTouched] = useState({
    email: false,
    phoneNumber: false,
    siteContactName: false,
    siteContactEmail: false,
    siteContactNumber: false,
    cpe: false,
    cpeSpecification: false
  });
  const [bwLoading, setBwLoading] = useState(false);

  // feasibility confirm warning popup
  // const [confirmFeasibilityPopup, setConfirmFeasibilityPopup] = useState(false);

  const getDefaultContactList = () => {
    const originalList = JSON.parse(JSON.stringify(upgradeDetails.customerContactList));
    const orderContactList =
      originalList &&
      originalList.map((item, index) => {
        item['key'] = index;
        item['displayName'] = `${item.firstName ? item.firstName : ''} ${item.lastName ? item.lastName : ''}`;
        !item['email'] ? (item['emailEmpty'] = true) : (item['emailEmpty'] = false);
        !item['phoneNumber'] ? (item['phoneNumberEmpty'] = true) : (item['phoneNumberEmpty'] = false);
        return item;
      });

    return orderContactList;
  };

  useEffect(() => {
    const orderContactList = getDefaultContactList();

    let selectedContactItem = orderContactList && orderContactList.find((item) => item.primary && item.responsibility === 'Authorized Signatory');

    // Customer contact list has no item with primary = true && responsibility = Authorized Signatory, then by default first Item will be selected and it's primary key will be set to true
    if (selectedContactItem === undefined) {
      orderContactList[0]['primary'] = true;
      selectedContactItem = orderContactList[0];
    }

    const selectedContactName = `${selectedContactItem.firstName || ''} ${selectedContactItem.lastName || ''}`.trim().toLowerCase();
    const selectedContactPhoneNumber = selectedContactItem.phoneNumber || '';

    const authorisedSignatoryName = `${(upgradeDetails.siteIncharge && upgradeDetails.siteIncharge.name) || ''}`.trim().toLowerCase();
    const authorisedSignatoryPhoneNumber = (upgradeDetails.siteIncharge && upgradeDetails.siteIncharge.phoneNumber) || '';

    // if siteInCharge is null, then checkbox should be checked by default
    const isSiteInchargeEmpty = !authorisedSignatoryName && !authorisedSignatoryPhoneNumber;
    const isContactEmailAndPhoneNonEmpty = !!(selectedContactName && selectedContactPhoneNumber);
    const isContactPhoneNumberValid = selectedContactPhoneNumber && mobileValidator(selectedContactPhoneNumber) && mobileValidator(selectedContactPhoneNumber).length === 0;

    let isChecked = selectedContactName === authorisedSignatoryName && selectedContactPhoneNumber === authorisedSignatoryPhoneNumber;

    setContactList(orderContactList);
    setSelectedContact(selectedContactItem);

    if (!isContactPhoneNumberValid) {
      isChecked = false;
    } else if (isSiteInchargeEmpty && isContactEmailAndPhoneNonEmpty) {
      isChecked = true;
    }

    setChecked(isChecked);
    setDefaultContactPhoneNumberValid(isContactPhoneNumberValid);

    populateDefaultFormData(
      pnqToken,
      upgradeDetails.cpeDetails,
      upgradeDetails.cpeSpecificationDetails,
      upgradeDetails.productName,
      upgradeDetails.serviceType,
      upgradeDetails.hardwareType
    );
  }, []);

  useEffect(() => {
    const leadStatus = upgradeDetails.leadStatus;
    // FOR KAM ACCORDION SHOULD NOT BE CLOSED
    const isPriceNegoStageForCustomer = userType === USER_TYPE.CUSTOMER && leadStatus === LEAD_STATUS.REQUIRED_PRICE_NEGOTIATION;

    const closedStatus =
      leadStatus === LEAD_STATUS.FEASIBILITY_COMPLETED ||
      leadStatus === LEAD_STATUS.LEAD_SUBMITTED ||
      leadStatus === LEAD_STATUS.KYC_IN_PROGRESS ||
      leadStatus === LEAD_STATUS.KYC_SUBMITTED ||
      isPriceNegoStageForCustomer;

    if (closedStatus) {
      setAccordionMeta({
        isExpanded: false
      });
    }

    // render notification
    renderFeasibilityNotification(upgradeDetails.leadStatus);
  }, [upgradeDetails.leadStatus]);

  useEffect(() => {
    let updatedSiteIncharge = {};
    const selectedContactPhoneNumber = selectedContact.phoneNumber || '';
    const isContactPhoneNumberValid = selectedContactPhoneNumber && mobileValidator(selectedContactPhoneNumber) && mobileValidator(selectedContactPhoneNumber).length === 0;
    const errorsCopy = Object.assign({}, errors);

    const getDefaultSiteIncharge = () => {
      const userFilledSiteInCharge = getFromSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.SITE_IN_CHARGE);

      return {
        name: (upgradeDetails.siteIncharge && upgradeDetails.siteIncharge.name) || (userFilledSiteInCharge && userFilledSiteInCharge.name) || '',
        phoneNumber: (upgradeDetails.siteIncharge && upgradeDetails.siteIncharge.phoneNumber) || (userFilledSiteInCharge && userFilledSiteInCharge.phoneNumber) || '',
        email: (upgradeDetails.siteIncharge && upgradeDetails.siteIncharge.email) || (userFilledSiteInCharge && userFilledSiteInCharge.email) || ''
      };
    };

    if (checked && selectedContact) {
      updatedSiteIncharge.name = `${selectedContact.firstName || ''} ${selectedContact.lastName || ''}`;
      updatedSiteIncharge.phoneNumber = selectedContact.phoneNumber || '';
      updatedSiteIncharge.email = selectedContact.email || '';
    } else {
      updatedSiteIncharge.name = getDefaultSiteIncharge().name;
      updatedSiteIncharge.phoneNumber = getDefaultSiteIncharge().phoneNumber;
      updatedSiteIncharge.email = getDefaultSiteIncharge().email;
    }

    if (updatedSiteIncharge.name) {
      errorsCopy['siteContactName'] = [];
    } else {
      errorsCopy['siteContactName'] = [FIELD_ERROR.REQUIRED];
    }

    if (updatedSiteIncharge.email) {
      errorsCopy['siteContactEmail'] = [];
    } else {
      errorsCopy['siteContactEmail'] = [FIELD_ERROR.REQUIRED];
    }

    const updatedSiteInchargeNumber = updatedSiteIncharge && updatedSiteIncharge.phoneNumber;
    const isUpdatedSiteInchargePhoneNumberValid =
      updatedSiteInchargeNumber && mobileValidator(updatedSiteInchargeNumber) && mobileValidator(updatedSiteInchargeNumber).length === 0;

    if (updatedSiteInchargeNumber) {
      if (isUpdatedSiteInchargePhoneNumberValid) {
        errorsCopy['siteContactNumber'] = [];
      } else {
        errorsCopy['siteContactNumber'] = [FIELD_ERROR.INVALID_NO];
        setFormTouched((formTouched) => ({
          ...formTouched,
          siteContactNumber: true
        }));
      }
    } else {
      errorsCopy['siteContactNumber'] = [FIELD_ERROR.REQUIRED];
      setFormTouched((formTouched) => ({
        ...formTouched,
        siteContactNumber: true
      }));
    }

    if (!isContactPhoneNumberValid) {
      errorsCopy['phoneNumber'] = [FIELD_ERROR.INVALID_NO];
      setFormTouched((formTouched) => ({
        ...formTouched,
        phoneNumber: true
      }));
    } else {
      errorsCopy['phoneNumber'] = [];
    }

    setSiteInCharge(updatedSiteIncharge);
    setErrors(errorsCopy);
  }, [checked, selectedContact]);

  const renderFeasibilityNotification = (leadStatus) => {
    const feasibilityStatus = upgradeDetails.feasibilityResponse;
    let message = '';
    let type = '';

    switch (leadStatus) {
      case LEAD_STATUS.FEASIBILITY_COMPLETED:
      case LEAD_STATUS.LEAD_SUBMITTED:
      case LEAD_STATUS.KYC_IN_PROGRESS:
      case LEAD_STATUS.REQUIRED_PRICE_NEGOTIATION:
      case LEAD_STATUS.PRICING_APPROVAL_REQUEST_SENT: {
        message = `Address Feasible upto ${
          Object.keys(selectedPrimaryMedia).length > 0 && selectedPrimaryMedia?.maxFeasibleBw ? selectedPrimaryMedia.maxFeasibleBw : feasibilityStatus.maxBandwidth
        } Mbps`;
        type = TOAST_TYPE.SUCCESS;
        break;
      }
      case LEAD_STATUS.FEASIBILITY_PENDING: {
        message = (
          <span>
            <img src={alert_warn} alt="Alert" /> Manual network check is required. Our team will update you within 24 hrs with the network status.
          </span>
        );
        type = TOAST_TYPE.WARNING;
        break;
      }
      case LEAD_STATUS.LOCATION_NOT_FEASIBLE: {
        message = (
          <span>
            <b>Not Feasible!</b> The installation address you entered is <b>Not Feasible</b>.
          </span>
        );
        type = TOAST_TYPE.ERROR;
        break;
      }
      default: {
        message = '';
        type = '';
      }
    }

    if (message && type) {
      setToastMsg(true, message, type);
    }
  };

  const setBandwidthListAndValue = () => {
    const { feasibilityResponse } = upgradeDetails;

    if (isValidObject(selectedPrimaryMedia) && isValidObject(feasibilityResponse)) {
      let requestedBandwidth = feasibilityResponse && feasibilityResponse.requestedBandwidth;
      const { primaryMediaList } = setMediaOptions(feasibilityResponse, requestedBandwidth);
      const selectedMediaItem = primaryMediaList.find((item) => item.key === selectedPrimaryMedia.key);
      const maxFeasibleBw = (selectedMediaItem && selectedMediaItem.maxFeasibleBw) || '';
      // using default bandwidth list for filtering based on media type selection - maxFeasibleBw
      let bandwidthListCopy = [...defaultBwList];

      const [selectedBwValue] = splittedBwValue(selectedBandwidth && selectedBandwidth.key);
      const isSelectedBwGreaterThanMediaMaxFeasibleBw = parseInt(selectedBwValue) > parseInt(maxFeasibleBw);

      const filteredList = bandwidthListCopy.filter((item) => {
        const [bwValue] = splittedBwValue(item.key);

        return parseInt(bwValue) <= parseInt(maxFeasibleBw);
      });

      setBandwidthList(filteredList);

      if (isSelectedBwGreaterThanMediaMaxFeasibleBw) {
        setSelectedBandwidth(filteredList[filteredList.length - 1]);
      }
    }
  };

  useEffect(() => {
    setBandwidthListAndValue();
  }, [selectedPrimaryMedia]);

  useEffect(() => {
    if (isShiftingJourney() && leadData && leadData.leadStatus && selectedBandwidth && selectedBandwidth.key) {
      filteredMediaOptions(selectedBandwidth);
    }
  }, [leadData.leadStatus, selectedBandwidth.key]);

  const populateDefaultFormData = (pnqToken, cpeDetails, cpeSpecDetails, productName, serviceType, hardwareType) => {
    const modifiedServiceTypeList = () => {
      let list = SERVICE_TYPE_LIST;
      if (productName === 'INTERNET') {
        list = list.filter((item) => item.key !== SERVICE_TYPE.PARTIALLY_MANAGED);
      }

      if (productName === 'MPLS' && serviceType === SERVICE_TYPE.PARTIALLY_MANAGED) {
        list = list.filter((item) => item.key !== SERVICE_TYPE.UNMANAGED);
      }

      return list;
    };

    const defaultServiceType = modifiedServiceTypeList().find((item) => item.key === serviceType) || {};

    const defaultHardwareType =
      defaultServiceType && defaultServiceType.key === SERVICE_TYPE.MANAGED ? HARDWARE_TYPE_LIST.find((item) => item.id === hardwareType) || HARDWARE_TYPE_LIST[0] : {};

    setServiceTypeList(modifiedServiceTypeList());
    setSelectedServiceType(defaultServiceType);
    setSelectedHardwareType(defaultHardwareType);
    setSelectedHardwareTypeLocal(defaultHardwareType);

    if (pnqToken && defaultServiceType && Object.keys(defaultServiceType).length > 0) {
      getBandwidthList(defaultServiceType, defaultHardwareType, cpeDetails, cpeSpecDetails);
    }
  };

  const filteredMediaOptions = (selectedBw = '') => {
    const media = getMediaType(leadData);
    const feasibilityResponse = getFeasibilityResponse(leadData);

    let selectedMedia = (media && media.value) || '';

    let requestedBandwidth = feasibilityResponse && feasibilityResponse.requestedBandwidth;

    if (selectedBw && selectedBw.key) {
      const [bwValue] = splittedBwValue(selectedBw.key);
      requestedBandwidth = bwValue;
    }

    const { primaryMediaList } = setMediaOptions(feasibilityResponse, requestedBandwidth);

    const getSelectedPrimaryMedia = () => {
      if (selectedMedia) {
        const filteredMediaItem = (primaryMediaList.length > 0 && primaryMediaList.find((item) => item.key === selectedMedia)) || {};

        if (Object.keys(filteredMediaItem).length > 0) {
          return filteredMediaItem;
        }

        return {
          id: selectedMedia,
          key: selectedMedia,
          displayName: selectedMedia
        };
      } else if (selectedPrimaryMedia && Object.keys(selectedPrimaryMedia).length > 0) {
        return selectedPrimaryMedia;
      } else {
        return primaryMediaList.length > 0 ? primaryMediaList[0] : {};
      }
    };

    const defaultPrimaryMedia = getSelectedPrimaryMedia();

    setPrimaryMediaOptions(primaryMediaList);
    setSelectedPrimaryMedia(defaultPrimaryMedia);
  };

  const getBandwidthList = async (defaultServiceType, defaultHardwareType, cpeDetails, cpeSpecDetails) => {
    try {
      setBwLoading(true);
      const selectedMedia = upgradeDetails?.media?.value;
      const { res, err } = await getPricingAsync(upgradeDetails.productName, defaultServiceType.key, pnqToken, selectedMedia);
      const result = await (res && res.data && res.data.result);

      const [oldBwValue] =
        upgradeDetails && upgradeDetails.oldLineItemDetails && upgradeDetails.oldLineItemDetails.bandwidth && upgradeDetails.oldLineItemDetails.bandwidth.split(' ');

      const [userSelectedBwValue] = (Object.keys(selectedBandwidth).length > 0 && selectedBandwidth.key && selectedBandwidth.key.split(' ')) || '';

      const maxFeasibleBw = upgradeDetails && upgradeDetails.feasibilityResponse && upgradeDetails.feasibilityResponse.maxBandwidth;

      const requestedFeasibleBw = upgradeDetails && upgradeDetails.feasibilityResponse && upgradeDetails.feasibilityResponse.requestedBandwidth;

      const [highestBwFromPricing] = (result && result.length > 0 && result[result.length - 1].bandwidth && result[result.length - 1].bandwidth.split(' ')) || '';

      const isRunningBwGreaterThanMaxFeasibleBw = maxFeasibleBw && parseInt(upgradeDetails.currentBw.value) > parseInt(maxFeasibleBw);
      const isRunningBwEqualToMaxFeasibleBw = maxFeasibleBw && parseInt(upgradeDetails.currentBw.value) === parseInt(maxFeasibleBw);

      const isRunningBwGreaterThanHighestBwFromPricing = parseInt(upgradeDetails.currentBw.value) > parseInt(highestBwFromPricing);
      const isRunningBwEqualToHighestBwFromPricing = parseInt(upgradeDetails.currentBw.value) === parseInt(highestBwFromPricing);

      const isValidBwScenario = !isRunningBwGreaterThanMaxFeasibleBw && !isRunningBwGreaterThanHighestBwFromPricing;

      const existingBwPrice = (currentBw) => {
        return (
          result.find((item) => {
            const [bandwidth] = item.bandwidth.split(' ');
            return parseInt(bandwidth) === parseInt(currentBw);
          }) || {}
        );
      };

      let filteredList = [];
      let selectedBw = {};

      if (err) {
        const errorMsg = getErrMsg(err);
        setBwLoading(false);
        setToastMsg(true, errorMsg, TOAST_TYPE.ERROR);
        throw new Error(errorMsg);
      }

      if (isRunningBwGreaterThanHighestBwFromPricing || isRunningBwGreaterThanMaxFeasibleBw) {
        setBlockJourney(true);
        const runningBw = () => {
          if (isRunningBwGreaterThanHighestBwFromPricing) {
            return `${highestBwFromPricing} Mbps`;
          }

          if (isRunningBwGreaterThanMaxFeasibleBw) {
            return `${maxFeasibleBw} Mbps`;
          }

          return `${upgradeDetails.currentBw.value} ${upgradeDetails.currentBw.unit}`;
        };

        const dropdownValue = {
          key: runningBw(),
          displayName: runningBw()
        };

        const selectedBwItemFromPricingList = existingBwPrice(dropdownValue.key);

        selectedBw = { ...selectedBwItemFromPricingList, ...dropdownValue };

        filteredList = [];
      } else {
        setBlockJourney(false);
      }

      if (isRunningBwEqualToMaxFeasibleBw || isRunningBwEqualToHighestBwFromPricing) {
        isRunningBwEqualToHighestBwFromPricing ? setBwAtMaxCircuit(true) : setBwAtMaxCircuit(false);
        const runningBw = `${upgradeDetails.currentBw.value} ${upgradeDetails.currentBw.unit}`;
        const dropdownValue = {
          key: runningBw,
          displayName: runningBw
        };

        const selectedBwItemFromPricingList = existingBwPrice(upgradeDetails.currentBw.value);

        selectedBw = { ...selectedBwItemFromPricingList, ...dropdownValue };
        // filteredList = [];
      } else {
        setBwAtMaxCircuit(false);
      }

      if (isValidBwScenario) {
        filteredList = result
          .filter((item) => {
            const [bandwidth] = item.bandwidth.split(' ');
            const isExistingBwLessThanMaxFeasibleBw = maxFeasibleBw && parseInt(Number(oldBwValue)) <= parseInt(maxFeasibleBw);

            // if (requestedFeasibleBw && maxFeasibleBw) {
            //   const isUpgBwGTReqFeasibleBw = parseInt(upgradeDetails.currentBw.value) > parseInt(requestedFeasibleBw);

            //   if (isUpgBwGTReqFeasibleBw) {
            //     return parseInt(bandwidth) >= parseInt(upgradeDetails.currentBw.value) && parseInt(bandwidth) <= parseInt(maxFeasibleBw);
            //   }

            //   return parseInt(bandwidth) >= parseInt(requestedFeasibleBw) && parseInt(bandwidth) <= parseInt(maxFeasibleBw);
            // }

            if (isExistingBwLessThanMaxFeasibleBw) {
              return parseInt(bandwidth) >= parseInt(Number(oldBwValue)) && parseInt(bandwidth) <= parseInt(maxFeasibleBw);
            }

            // if (parseInt(upgradeDetails.currentBw.value) >= parseInt(Number(oldBwValue))) {
            //   return parseInt(bandwidth) >= parseInt(upgradeDetails.currentBw.value);
            // }

            return parseInt(bandwidth) >= parseInt(Number(oldBwValue));
          })
          .map((bwItem) => {
            bwItem['key'] = bwItem.bandwidth;
            bwItem['displayName'] = bwItem.bandwidth;
            return bwItem;
          });

        selectedBw =
          filteredList.find((item) => {
            const [bandwidth] = item.bandwidth.split(' ');
            if (userSelectedBwValue) {
              return parseInt(bandwidth) === parseInt(userSelectedBwValue);
            }

            return parseInt(bandwidth) === parseInt(upgradeDetails.currentBw.value);
          }) || filteredList[0];
      }

      const [selectedBwValue] = selectedBw && selectedBw.key && selectedBw.key.split(' ');

      if (selectedBwValue && maxFeasibleBw) {
        const isSelectedBwGreaterThanMaxBw = maxFeasibleBw ? parseInt(selectedBwValue) >= parseInt(maxFeasibleBw) : false;

        isSelectedBwGreaterThanMaxBw ? setShowMaxBwText(true) : setShowMaxBwText(false);
      }

      checkIfValuesChanged('bandwidth', selectedBw);
      setBandwidthList(filteredList);

      // keeping default bandwidth list for media type change filtering based on maxFeasibleBw in setBandwidthListAndValue fn
      setDefaultBwList(filteredList);

      setSelectedBandwidth(selectedBw);

      // set feasible media list
      filteredMediaOptions(selectedBw);

      // Set Hardware List(cpe/ cpeSpec) list and values

      if (defaultServiceType.key === SERVICE_TYPE.MANAGED) {
        defaultHardwareType.id === 'Standard'
          ? getStandardRouterDetails(selectedBw, cpeDetails, cpeSpecDetails, defaultHardwareType, defaultServiceType)
          : getNonStandardRouterDetails(selectedBw, cpeDetails, cpeSpecDetails, defaultHardwareType, defaultServiceType);
      }

      setBwLoading(false);
    } catch (e) {
      console.error(e);
    }
  };

  const getStandardRouterDetails = async (selectedBandwidth, cpeDetails, cpeSpecDetails, defaultHardwareType, defaultServiceType) => {
    try {
      const { res, err } = await getCpeAsync(
        selectedBandwidth,
        upgradeDetails.orderType,
        upgradeDetails.source,
        upgradeDetails.productName,
        upgradeDetails.leadSegment,
        pnqToken,
        ROUTERS.STANDARD
      );
      const result = await (res && res.data && res.data.result);
      const router = await (result && result[selectedBandwidth.key] && result[selectedBandwidth.key].router);

      const cpeList = Object.keys(router).map((item) => {
        const modifiedItem = {
          key: item,
          displayName: item
        };

        return modifiedItem;
      });

      if (err) {
        const errorMsg = getErrMsg(err);
        setToastMsg(true, errorMsg, TOAST_TYPE.ERROR);
        setCpeList([]);
        throw new Error(errorMsg);
      }

      setRouterSpecsMasterList(router);
      setCpeList(cpeList);

      getCpeSpecDetails(cpeList, cpeDetails, router, cpeSpecDetails, defaultHardwareType, defaultServiceType);
    } catch (e) {
      console.error('Error fetching router specs from standard getCPE api');
    }
  };

  const getNonStandardRouterDetails = async (selectedBandwidth, cpeDetails, cpeSpecDetails, defaultHardwareType, defaultServiceType) => {
    try {
      const { res: commAttrSuccessRes, err: commAttrErrRes } = await getNonStandardCpeAsync(upgradeDetails.productName === 'INTERNET' ? 'DEDICATED_INTERNET' : 'VPN', pnqToken);
      const { res, err } = await getCpeAsync(
        selectedBandwidth,
        upgradeDetails.orderType,
        upgradeDetails.source,
        upgradeDetails.productName,
        upgradeDetails.leadSegment,
        pnqToken,
        ROUTERS.NON_STANDARD
      );

      const commAttrResult = await (commAttrSuccessRes && commAttrSuccessRes.data && commAttrSuccessRes.data.result);
      const router = await (commAttrResult && commAttrResult.commercialAttributes);

      const result = await res?.data?.result;
      const nonStandardRouterMap = await result?.[selectedBandwidth.key]?.router;

      let cpeList = [];
      let cpeSpecification = {};

      cpeList = Object.keys(nonStandardRouterMap).map((item) => {
        const modifiedItem = {
          key: item,
          displayName: item
        };

        return modifiedItem;
      });

      Object.entries(nonStandardRouterMap)?.map(([make, models]) => {
        const modelList = [];
        if (Array.isArray(models) && models?.length > 0) {
          models?.forEach((model) => {
            if (model['model']) {
              modelList.push(model['model']);
            }
          });
        }
        cpeSpecification[make] = modelList;
      });

      router['cpe'] = [...new Set(Object.keys(cpeSpecification))];
      router['cpeSpecification'] = cpeSpecification;

      if (commAttrErrRes || err) {
        const errorMsg = getErrMsg(commAttrErrRes || err);
        setToastMsg(true, errorMsg, TOAST_TYPE.ERROR);
        setCpeList([]);
        throw new Error(errorMsg);
      }

      setRouterSpecsMasterList(router);
      setCpeList(cpeList);

      getCpeSpecDetails(cpeList, cpeDetails, router, cpeSpecDetails, defaultHardwareType, defaultServiceType);
    } catch (e) {
      console.error(e ?? 'Error fetching non standard router specs from CPQ');
    }
  };

  const getCpeSpecDetails = (cpeList, cpeDetails, routerMasterList, cpeSpecificationDetails, defaultHardwareType, defaultServiceType) => {
    if (cpeList && cpeList.length > 0) {
      if ((cpeDetails && cpeDetails.name === 'cpe' && cpeDetails.value) || defaultServiceType.key === SERVICE_TYPE.MANAGED) {
        const selectedItem = cpeList.find((item) => item.key === cpeDetails.value) || cpeList[0];
        setSelectedCpe(selectedItem);
        Object.keys(selectedItem).length > 0
          ? setErrors((errors) => ({
              ...errors,
              cpe: []
            }))
          : setErrors((errors) => ({
              ...errors,
              cpe: [FIELD_ERROR.REQUIRED]
            }));
        checkIfValuesChanged('cpe', selectedItem);
        getCpeSpecificationDetails(selectedItem, cpeSpecificationDetails, routerMasterList, defaultHardwareType, defaultServiceType);
      } else {
        setSelectedCpe({});
        setCpeSpecificationList([]);
        setSelectedCpeSpecification({});
        setErrors((errors) => ({
          ...errors,
          cpe: [FIELD_ERROR.REQUIRED]
        }));
        setErrors((errors) => ({
          ...errors,
          cpeSpecification: [FIELD_ERROR.REQUIRED]
        }));
        checkIfValuesChanged('cpe', {});
        checkIfValuesChanged('cpeSpecification', {});
      }
    } else {
      setRouterSpecsMasterList([]);
      setCpeList([]);
      setSelectedCpe({});
      setCpeSpecificationList([]);
      setSelectedCpeSpecification({});
      setErrors((errors) => ({
        ...errors,
        cpe: [FIELD_ERROR.REQUIRED]
      }));
      setErrors((errors) => ({
        ...errors,
        cpeSpecification: [FIELD_ERROR.REQUIRED]
      }));
      checkIfValuesChanged('cpe', {});
      checkIfValuesChanged('cpeSpecification', {});
    }
  };

  const getCpeSpecificationDetails = (selectedCpe, cpeSpecificationDetails, routerMasterList, defaultHardwareType, defaultServiceType) => {
    let specificationList = [];
    if (defaultHardwareType.id === 'Standard') {
      specificationList =
        routerMasterList &&
        routerMasterList.hasOwnProperty(selectedCpe.key) &&
        routerMasterList[selectedCpe.key].map((item) => {
          item['key'] = item.model;
          item['displayName'] = item.model;
          return item;
        });
    } else {
      routerMasterList.cpeSpecification &&
        routerMasterList.cpeSpecification.hasOwnProperty(selectedCpe.key) &&
        routerMasterList.cpeSpecification[selectedCpe.key].forEach((item) => {
          let modifiedItem = {};
          modifiedItem['key'] = item;
          modifiedItem['displayName'] = item;
          specificationList.push(modifiedItem);
        });
    }

    setCpeSpec(specificationList, cpeSpecificationDetails, defaultServiceType);
  };

  const setCpeSpec = (cpeSpecificationList, cpeSpecificationDetails, defaultServiceType) => {
    if (Array.isArray(cpeSpecificationList) && cpeSpecificationList.length > 0) {
      setCpeSpecificationList(cpeSpecificationList);

      if ((cpeSpecificationDetails && cpeSpecificationDetails.name === 'cpeSpecification' && cpeSpecificationDetails.value) || defaultServiceType.key === SERVICE_TYPE.MANAGED) {
        const selectedItem = cpeSpecificationList.find((item) => item.key === cpeSpecificationDetails.value) || cpeSpecificationList[0];
        setSelectedCpeSpecification(selectedItem);
        Object.keys(selectedItem).length > 0
          ? setErrors((errors) => ({
              ...errors,
              cpeSpecification: []
            }))
          : setErrors((errors) => ({
              ...errors,
              cpeSpecification: [FIELD_ERROR.REQUIRED]
            }));
        checkIfValuesChanged('cpeSpecification', selectedItem);
      } else {
        setSelectedCpeSpecification({});
        setErrors((errors) => ({
          ...errors,
          cpeSpecification: [FIELD_ERROR.REQUIRED]
        }));
        checkIfValuesChanged('cpeSpecification', {});
      }
    } else {
      setCpeSpecificationList([]);
      setSelectedCpeSpecification({});
      setErrors((errors) => ({
        ...errors,
        cpeSpecification: [FIELD_ERROR.REQUIRED]
      }));
      checkIfValuesChanged('cpeSpecification', {});
    }
  };

  const handleContactChange = (value) => {
    checkIfFormUpdatedAfterFeasibility();
    checkIfValuesChanged('selectedContact', value);
    const orderContactList = getDefaultContactList();
    const updatedContactList = orderContactList.map((item) => {
      if (item.key === value.key) {
        item['primary'] = true;
        item['responsibility'] = 'Authorized Signatory';
      } else {
        item['primary'] = false;
      }
      return item;
    });

    const selectedContactName = `${value.firstName || ''} ${value.lastName || ''}`.trim().toLowerCase();
    const selectedContactPhoneNumber = value.phoneNumber || '';
    const isContactPhoneNumberValid = selectedContactPhoneNumber && mobileValidator(selectedContactPhoneNumber) && mobileValidator(selectedContactPhoneNumber).length === 0;

    const authorisedSignatoryName = `${(upgradeDetails.siteIncharge && upgradeDetails.siteIncharge.name) || ''}`.trim().toLowerCase();
    const authorisedSignatoryPhoneNumber = (upgradeDetails.siteIncharge && upgradeDetails.siteIncharge.phoneNumber) || '';

    // if siteInCharge is null, then checkbox should be checked by default
    const isSiteInchargeEmpty = !authorisedSignatoryName && !authorisedSignatoryPhoneNumber;
    const isContactEmailAndPhoneNonEmpty = !!(selectedContactName && selectedContactPhoneNumber);

    let isChecked = selectedContactName === authorisedSignatoryName && selectedContactPhoneNumber === authorisedSignatoryPhoneNumber;

    if (!isContactPhoneNumberValid) {
      isChecked = false;
    } else if (isSiteInchargeEmpty && isContactEmailAndPhoneNonEmpty) {
      isChecked = true;
    }

    setChecked(isChecked);
    setDefaultContactPhoneNumberValid(isContactPhoneNumberValid);
    setContactList(updatedContactList);
    setSelectedContact(value);
  };

  const isSelectedContactValid = () => {
    const selectedContactName = `${selectedContact.firstName || ''} ${selectedContact.lastName || ''}`.trim().toLowerCase();
    const selectedContactPhoneNumber = selectedContact.phoneNumber || '';
    const isPhoneNoValid = selectedContactPhoneNumber && mobileValidator(selectedContactPhoneNumber) && mobileValidator(selectedContactPhoneNumber).length === 0;

    return !!(selectedContactName && selectedContactPhoneNumber && isPhoneNoValid);
  };

  const validateAndUpdateErrors = (key, value) => {
    let errorList = [];

    if (key === 'email' || key === 'siteContactEmail') {
      errorList = emailValidator(value);
    }

    if (key === 'siteContactNumber') {
      errorList = mobileValidator(value);
    }

    if (key === 'phoneNumber') {
      errorList = mobileValidator(value);

      if (Array.isArray(errorList) && errorList.length > 0) {
        setChecked(false);
      }
    }

    if (key === 'cpe' || key === 'cpeSpecification' || key === 'siteContactName' || key === 'siteContactNumber' || key === 'siteContactEmail') {
      const isValueSelected = value && Object.keys(value).length > 0;

      if (!isValueSelected) {
        errorList.unshift(FIELD_ERROR.REQUIRED);
      }
    }

    setErrors((errors) => ({
      ...errors,
      [key]: errorList
    }));

    setFormTouched((formTouched) => ({
      ...formTouched,
      [key]: true
    }));
  };

  const handleContactFormInputChange = (key, value) => {
    checkIfFormUpdatedAfterFeasibility();
    validateAndUpdateErrors(key, value);
    checkIfValuesChanged(key, value);
    const updatedContactList = contactList.map((item) => {
      if (item.key === selectedContact.key) {
        item[key] = value;
        item['primary'] = true;
        item['responsibility'] = CUSTOMER_ROLE.AUTHORIZED_SIGNATORY;
      }
      return item;
    });

    const updatedContactValue = updatedContactList.find((item) => item.key === selectedContact.key);

    setContactList(updatedContactList);
    setSelectedContact(updatedContactValue);
  };

  const handleSiteFormInputChange = (key, value) => {
    checkIfFormUpdatedAfterFeasibility();
    validateAndUpdateErrors(key, value);
    checkIfValuesChanged(key, value);

    if (key === 'siteContactName') {
      siteInCharge['name'] = value;
    }

    if (key === 'siteContactNumber') {
      siteInCharge['phoneNumber'] = value;
    }

    if (key === 'siteContactEmail') {
      siteInCharge['email'] = value;
    }
    // siteInCharge[key === 'siteContactName' ? 'name' : 'phoneNumber'] = value;
    setSiteInCharge(siteInCharge);
    setInSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.SITE_IN_CHARGE, siteInCharge);
  };

  const handleBandwidthChange = (value) => {
    checkIfFormUpdatedAfterFeasibility();
    const maxBw = upgradeDetails.feasibilityResponse && upgradeDetails.feasibilityResponse.maxBandwidth;
    const [bwValue] = value && value.key && value.key.split(' ');
    const isSelectedBwGreaterThanMaxBw = maxBw ? parseInt(bwValue) > parseInt(maxBw) : false;

    isSelectedBwGreaterThanMaxBw ? setShowMaxBwText(true) : setShowMaxBwText(false);

    const modifiedValue = isSelectedBwGreaterThanMaxBw
      ? bandwidthList.find((item) => {
          const [bandwidth] = item.bandwidth.split(' ');
          return parseInt(bandwidth) === parseInt(maxBw);
        })
      : value;

    setSelectedBandwidth(modifiedValue);
    checkIfValuesChanged('bandwidth', value);

    // update media list

    filteredMediaOptions(modifiedValue);

    // fetch bw router details
    if (selectedServiceType.key === SERVICE_TYPE.MANAGED) {
      selectedHardwareTypeLocal.id === 'Standard'
        ? getStandardRouterDetails(modifiedValue, upgradeDetails.cpeDetails, upgradeDetails.cpeSpecificationDetails, selectedHardwareTypeLocal, selectedServiceType)
        : getNonStandardRouterDetails(modifiedValue, upgradeDetails.cpeDetails, upgradeDetails.cpeSpecificationDetails, selectedHardwareTypeLocal, selectedServiceType);
    }
  };

  const handleMediaChange = (value) => {
    checkIfFormUpdatedAfterFeasibility();
    setSelectedPrimaryMedia(value);
    checkIfValuesChanged('media', value);
  };

  const handleServiceTypeChange = (value) => {
    checkIfFormUpdatedAfterFeasibility();
    setSelectedServiceType(value);
    checkIfValuesChanged('serviceType', value);

    // fetch bw list as per service type
    const standardHardware = HARDWARE_TYPE_LIST.find((item) => item?.id === HARDWARE_TYPE.STANDARD);
    const defaultHardwareType = (value && value.key === SERVICE_TYPE.MANAGED && standardHardware) || {};

    setSelectedHardwareType(defaultHardwareType);
    setSelectedHardwareTypeLocal(defaultHardwareType);

    getBandwidthList(value, defaultHardwareType, upgradeDetails.cpeDetails, upgradeDetails.cpeSpecificationDetails);
  };

  const handleHardwareTypeChange = (value) => {
    const standardHardware = HARDWARE_TYPE_LIST.find((item) => item?.id === HARDWARE_TYPE.STANDARD);
    const nonStandardHardware = HARDWARE_TYPE_LIST.find((item) => item?.id === HARDWARE_TYPE.NON_STANDARD);
    const selectedHardwareData = value === true ? nonStandardHardware : standardHardware;

    checkIfFormUpdatedAfterFeasibility();
    setSelectedHardwareType(selectedHardwareData);
    setSelectedHardwareTypeLocal(selectedHardwareData);

    // fetch bw router details
    if (selectedServiceType.key === SERVICE_TYPE.MANAGED) {
      !value
        ? getStandardRouterDetails(selectedBandwidth, upgradeDetails.cpeDetails, upgradeDetails.cpeSpecificationDetails, selectedHardwareData, selectedServiceType)
        : getNonStandardRouterDetails(selectedBandwidth, upgradeDetails.cpeDetails, upgradeDetails.cpeSpecificationDetails, selectedHardwareData, selectedServiceType);
    }
  };

  const handleCpeChange = (key, value) => {
    checkIfFormUpdatedAfterFeasibility();
    validateAndUpdateErrors(key, value);
    checkIfValuesChanged(key, value);
    setSelectedCpe(value);
    getCpeSpecificationDetails(value, {}, routerSpecsMasterList, selectedHardwareTypeLocal, selectedServiceType);
  };

  const handleCpeSpecificationChange = (key, value) => {
    checkIfFormUpdatedAfterFeasibility();
    validateAndUpdateErrors(key, value);
    checkIfValuesChanged(key, value);
    setSelectedCpeSpecification(value);
  };

  const isDisabled = () => {
    let disabled = false;

    if (userType === USER_TYPE.CUSTOMER) {
      disabled = !(upgradeDetails.leadStatus === LEAD_STATUS.LEAD_IN_PROGRESS || upgradeDetails.leadStatus === LEAD_STATUS.FEASIBILITY_COMPLETED) || blockJourney;
    }
    if (userType === USER_TYPE.KAM) {
      disabled =
        !(
          upgradeDetails.leadStatus === LEAD_STATUS.LEAD_IN_PROGRESS ||
          upgradeDetails.leadStatus === LEAD_STATUS.FEASIBILITY_COMPLETED ||
          upgradeDetails.leadStatus === LEAD_STATUS.REQUIRED_PRICE_NEGOTIATION
        ) || blockJourney;
    }
    return disabled;
  };

  const checkIfValuesChanged = (key, value) => {
    if (key === 'bandwidth') {
      const oldBwValue = upgradeDetails?.oldLineItemDetails?.bandwidth;
      const existingBw = `${upgradeDetails.currentBw.value} ${upgradeDetails.currentBw.unit}`;

      const upgradeFormBwChanged = value.key !== oldBwValue;

      setErrors((errors) => ({
        ...errors,
        upgradeFormBwChanged
      }));

      return false;
    }

    if (key === 'media') {
      const existingMedia = `${upgradeDetails.media.value}`;
      const upgradeFormMediaChanged = value.key !== existingMedia;
      setErrors((errors) => ({
        ...errors,
        upgradeFormMediaChanged
      }));

      return false;
    }

    if (key === 'serviceType') {
      const selectedService = upgradeDetails.serviceType;
      const upgradeFormServiceTypeChanged = value.key !== selectedService;
      setErrors((errors) => ({
        ...errors,
        upgradeFormServiceTypeChanged
      }));

      return false;
    }

    if (key === 'cpe') {
      const existingCpe = upgradeDetails.cpeDetails && upgradeDetails.cpeDetails.key;
      setErrors((errors) => ({
        ...errors,
        upgradeFormHardwareDetailsChanged: value.key !== existingCpe
      }));

      return false;
    }

    if (key === 'cpeSpecification') {
      const existingCpeSpec = upgradeDetails.cpeSpecificationDetails && upgradeDetails.cpeSpecificationDetails.key;
      setErrors((errors) => ({
        ...errors,
        upgradeFormHardwareDetailsChanged: value.key !== existingCpeSpec
      }));

      return false;
    }

    if (key === 'selectedContact') {
      const existingContact = selectedContact && selectedContact.key;
      setErrors((errors) => ({
        ...errors,
        upgradeFormContactChanged: value.key !== existingContact
      }));

      return false;
    }

    if (key === 'email') {
      const existingEmail = selectedContact && selectedContact.email;
      setErrors((errors) => ({
        ...errors,
        upgradeFormContactChanged: value !== existingEmail
      }));

      return false;
    }

    if (key === 'phoneNumber') {
      const existingPhoneNumber = selectedContact && selectedContact.phoneNumber;

      setErrors((errors) => ({
        ...errors,
        upgradeFormContactChanged: value !== existingPhoneNumber
      }));

      return false;
    }

    if (key === 'siteContactName') {
      const existingName = upgradeDetails.siteIncharge && upgradeDetails.siteIncharge.name;
      setErrors((errors) => ({
        ...errors,
        upgradeFormAuthorisedSignatoryChanged: value !== existingName
      }));

      return false;
    }

    if (key === 'siteContactNumber') {
      const existingNumber = upgradeDetails.siteIncharge && upgradeDetails.siteIncharge.phoneNumber;
      setErrors((errors) => ({
        ...errors,
        upgradeFormAuthorisedSignatoryChanged: value !== existingNumber
      }));

      return false;
    }

    if (key === 'siteContactEmail') {
      const existingEmail = upgradeDetails.siteIncharge && upgradeDetails.siteIncharge.email;
      setErrors((errors) => ({
        ...errors,
        upgradeFormAuthorisedSignatoryChanged: value !== existingEmail
      }));

      return false;
    }

    setErrors((errors) => ({
      ...errors,
      upgradeFormBwChanged: false,
      upgradeFormMediaChanged: false,
      upgradeFormServiceTypeChanged: false,
      upgradeFormHardwareDetailsChanged: false,
      upgradeFormAuthorisedSignatoryChanged: false
    }));
  };

  const checkIfFormUpdatedAfterFeasibility = () => {
    if (userType === USER_TYPE.CUSTOMER) {
      upgradeDetails.leadStatus === LEAD_STATUS.FEASIBILITY_COMPLETED && setIsPnqFormOpen(false);
    }
    if (userType === USER_TYPE.KAM) {
      (upgradeDetails.leadStatus === LEAD_STATUS.FEASIBILITY_COMPLETED || upgradeDetails.leadStatus === LEAD_STATUS.REQUIRED_PRICE_NEGOTIATION) && setIsPnqFormOpen(false);
    }
  };

  const showServiceTypeDropdown = () => {
    const currentServiceType = upgradeDetails && upgradeDetails.serviceType;
    let showDropdown = true;

    if (currentServiceType === SERVICE_TYPE.MANAGED) {
      showDropdown = false;
    } else {
      showDropdown = true;
    }

    return showDropdown;
  };

  const getIsLeoCustomer = (leadData) => {
    return (leadData && leadData.customer && leadData.customer.migrationFlag) || 'Y'; // null should be treated as Y --> LEO CUSTOMER
  };

  const getHardwareTypesList = () => {
    const isLeoCustomer = getIsLeoCustomer(leadData);

    if (isLeoCustomer === 'Y') {
      return HARDWARE_TYPE_LIST.filter((item) => item.id !== HARDWARE_TYPE.NON_STANDARD);
    }

    return HARDWARE_TYPE_LIST;
  };

  const showMediaTypeDropdown = useCallback(() => {
    const currentLeadStatus = leadData.leadStatus;

    const isMediaTypeVisible =
      currentLeadStatus !== LEAD_STATUS.LEAD_IN_PROGRESS && currentLeadStatus !== LEAD_STATUS.FEASIBILITY_PENDING && currentLeadStatus !== LEAD_STATUS.LOCATION_NOT_FEASIBLE;

    return isMediaTypeVisible;
  }, [leadData.leadStatus]);

  const getFeasibilityStatusField = () => {
    const leadStatus = leadData.leadStatus;
    const feasibilityStatus = upgradeDetails.feasibilityResponse;

    switch (leadStatus) {
      case LEAD_STATUS.FEASIBILITY_COMPLETED:
      case LEAD_STATUS.LEAD_SUBMITTED:
      case LEAD_STATUS.KYC_IN_PROGRESS:
      case LEAD_STATUS.REQUIRED_PRICE_NEGOTIATION:
      case LEAD_STATUS.PRICING_APPROVAL_REQUEST_SENT: {
        const maxFeasibleBw = Object.keys(selectedPrimaryMedia).length > 0 ? selectedPrimaryMedia.maxFeasibleBw : feasibilityStatus.maxBandwidth;
        return maxFeasibleBw ? (
          <Fragment>
            <img src={dotGreen} alt="dot-green" style={{ margin: '0 5px 0 0' }} />
            <span>{`Feasible Upto ${maxFeasibleBw} Mbps`}</span>
          </Fragment>
        ) : null;
      }
      case LEAD_STATUS.FEASIBILITY_PENDING: {
        return (
          <Fragment>
            <img src={dotWarn} alt="dot-warn" style={{ margin: '0 5px 0 0' }} />
            <span>Under Manual Network Check</span>
            {feasibilityStatus.cbftTaskId && <p>Feasibility ID: {feasibilityStatus.cbftTaskId}</p>}
          </Fragment>
        );
      }
      case LEAD_STATUS.LOCATION_NOT_FEASIBLE: {
        return (
          <Fragment>
            <img src={dotRed} alt="dot-red" style={{ margin: '0 5px 0 0' }} />
            <span>Not Feasible</span>
          </Fragment>
        );
      }
      default: {
        return null;
      }
    }
  };

  const showFooter = () => {
    const leadStatus = upgradeDetails.leadStatus;

    if (leadStatus === LEAD_STATUS.LEAD_IN_PROGRESS && isShiftingJourney()) {
      return false;
    }

    return (
      leadStatus === LEAD_STATUS.LEAD_IN_PROGRESS ||
      leadStatus === LEAD_STATUS.FEASIBILITY_PENDING ||
      leadStatus === LEAD_STATUS.LOCATION_NOT_FEASIBLE ||
      (userType === USER_TYPE.CUSTOMER && leadStatus === LEAD_STATUS.FEASIBILITY_COMPLETED && !pnqFormOpen) ||
      (userType === USER_TYPE.KAM && (leadStatus === LEAD_STATUS.FEASIBILITY_COMPLETED || leadStatus === LEAD_STATUS.REQUIRED_PRICE_NEGOTIATION) && !pnqFormOpen)
    );
  };

  const onSubmitCb = (feasibilityResponse) => {
    checkShiftingFeasibility(feasibilityResponse);
    // setConfirmFeasibilityPopup(true);
  };

  const getNewInstallationAddress = () => {
    if (upgradeDetails.feasibilityResponse) {
      return upgradeDetails.feasibilityResponse?.address?.addressString;
    }

    if (savedFeasibilityData) {
      return savedFeasibilityData?.address ?? savedFeasibilityData?.addressObj?.addressString;
    }

    return '-';
  };

  const renderShiftingNewInstallationAddress = () => {
    return (
      leadData?.leadStatus !== LEAD_STATUS.LEAD_IN_PROGRESS && (
        <div className="flg-lg-6 flg-md-6 flg-sm-12">
          <label>New Installation Address</label>
          <div style={{ marginTop: 5 }}>{getNewInstallationAddress()}</div>
        </div>
      )
    );
  };

  return (
    <div className="upgrade-order-details upgrade-accordion">
      {showKnowMorePopup && <KnowMorePopup setShowManageServices={setShowKnowMorePopup} productName={upgradeDetails.productName} />}
      {/* {confirmFeasibilityPopup && (
        <CustomModal
          customPopupTitle="Perform feasibility check"
          customPopupMsg="Address can not be updated once feasibility has been performed."
          submitCustomPopup={() => {
            setConfirmFeasibilityPopup(false);
          }}
          closeCustomPopup={() => setConfirmFeasibilityPopup(false)}
          // loading={loading}
          // leadData={leadData}
        />
      )} */}
      <Accordion
        autoScrollOnExpand={false}
        title={
          <TitleComponent
            isExpanded={accordionMeta.isExpanded}
            currentBw={selectedBandwidth && selectedBandwidth.key}
            serviceType={selectedServiceType && selectedServiceType.key}
            hardwareType={selectedHardwareTypeLocal && selectedHardwareTypeLocal.id}
            feasibilityStatus={upgradeDetails.feasibilityResponse}
            media={upgradeDetails.media}
            selectedPrimaryMedia={selectedPrimaryMedia}
            leadStatus={upgradeDetails.leadStatus}
            createLead={createLead}
            blockJourney={blockJourney}
            bwAtMaxCircuit={bwAtMaxCircuit}
            eligibleMedia={upgradeDetails.eligibleMedia}
            showMediaTypeDropdown={showMediaTypeDropdown}
          />
        }
        isExpanded={accordionMeta.isExpanded}
        onExpandClick={() =>
          setAccordionMeta((accordionMeta) => ({
            ...accordionMeta,
            isExpanded: !accordionMeta.isExpanded
          }))
        }
        variant="round"
      >
        <div className="upgrade-body">
          <div className="row margin-bottom">
            {renderShiftingNewInstallationAddress()}
            {leadData?.leadStatus !== LEAD_STATUS.LEAD_IN_PROGRESS && getFeasibilityStatusField() && (
              <div className="flg-lg-6 flg-md-6 flg-sm-12">
                <label>Feasibility Status</label>
                <div style={{ marginTop: 5 }}>{getFeasibilityStatusField()}</div>
              </div>
            )}
          </div>
          <div className="row">
            <div className="flg-lg-6 flg-md-6 flg-sm-12">
              <div
                className={classNames({
                  'control_group bw_selectbox': true,
                  'd-flex': bwLoading
                })}
              >
                <Select
                  placeholder=""
                  label="Required Bandwidth"
                  value={selectedBandwidth}
                  onChange={handleBandwidthChange}
                  options={bandwidthList}
                  required
                  touched
                  disabled={isDisabled() || isShiftingJourney()}
                />
                {bwLoading && <span className="loading_icon"></span>}
              </div>
              {showMaxBwText && (
                <span
                  style={{
                    position: 'relative',
                    top: '-15px',
                    color: '#ef8d07',
                    left: '7px'
                  }}
                >{`Maximum feasible bandwidth: ${upgradeDetails.feasibilityResponse && upgradeDetails.feasibilityResponse.maxBandwidth} Mbps`}</span>
              )}
            </div>
            {showMediaTypeDropdown() && (
              <div className="flg-lg-6 flg-md-6 flg-sm-12">
                <div className="control_group">
                  <Select
                    placeholder=""
                    label="Media Type"
                    value={selectedPrimaryMedia}
                    onChange={handleMediaChange}
                    options={primaryMediaOptions}
                    disabled={isDisabled()}
                    required
                    touched
                  />
                  {selectedPrimaryMedia && selectedPrimaryMedia.key === MEDIA_TYPES.OFFNET && (
                    <div className="info-text additional_info">
                      <span className="material-icons-outlined additional_info_icon">info</span>
                      &nbsp; Additional CAPEX charges may apply
                    </div>
                  )}
                  {selectedPrimaryMedia && selectedPrimaryMedia.key === MEDIA_TYPES.THIRD_PARTY && (
                    <div className="info-text additional_info">
                      <span className="material-icons-outlined additional_info_icon">info</span>
                      &nbsp; Additional Third Party charges may apply
                    </div>
                  )}
                </div>
              </div>
            )}
            <div className="flg-lg-6 flg-md-6 flg-sm-12">
              <div className="control_group">
                <Select
                  placeholder=""
                  label="Service Type"
                  value={selectedServiceType}
                  onChange={handleServiceTypeChange}
                  options={serviceTypeList}
                  required
                  touched
                  disabled={isDisabled() || !showServiceTypeDropdown() || isShiftingJourney()}
                />
              </div>
              <div className="know_more_container">
                <span className="know_more" onClick={() => setShowKnowMorePopup(true)}>
                  <i className="material-icons-outlined">info</i> Know more
                </span>
              </div>
            </div>
          </div>
          {selectedServiceType.key === SERVICE_TYPE.MANAGED && !isShiftingJourney() && (
            <React.Fragment>
              {upgradeDetails?.customerDetail?.segment === 'ENTERPRISE' && (
                <div className={`radio_group_option hardware_checkbox ${getIsLeoCustomer(leadData) === 'Y' ? 'leo-customer' : 'aeh-customer'}`}>
                  <Checkbox
                    checked={selectedHardwareTypeLocal.id === HARDWARE_TYPE.NON_STANDARD}
                    onChange={handleHardwareTypeChange}
                    disabled={isDisabled() || isShiftingJourney()}
                  >
                    <span className="check_text">Non-standard hardware. (Additional charges may apply)</span>
                  </Checkbox>
                </div>
              )}
              <div className="row">
                <div className="flg-lg-6 flg-md-6 flg-sm-12">
                  <div className="control_group">
                    <Select
                      placeholder=""
                      label="Hardware Specification*"
                      name="cpe"
                      value={selectedCpe}
                      onChange={(value) => handleCpeChange('cpe', value)}
                      options={cpeList}
                      errors={submitClicked || formTouched.cpe ? errors.cpe : []}
                      required
                      touched
                      disabled={isDisabled() || isShiftingJourney()}
                    />
                  </div>
                </div>
                <div className="flg-lg-6 flg-md-6 flg-sm-12">
                  <div className="control_group">
                    <Select
                      placeholder=""
                      label="Type of Hardware (CPE Type)*"
                      name="cpeSpecification"
                      value={selectedCpeSpecification}
                      onChange={(value) => handleCpeSpecificationChange('cpeSpecification', value)}
                      options={cpeSpecificationList}
                      errors={submitClicked || formTouched.cpeSpecification ? errors.cpeSpecification : []}
                      required
                      touched
                      disabled={isDisabled() || isShiftingJourney()}
                    />
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
          <div className="site-contact-label">Site Contact Person Details</div>
          <div className="row">
            <div className="flg-lg-6 flg-md-6 flg-sm-12">
              <Input
                type="text"
                label="Site Contact Name*"
                name="siteContactName"
                value={siteInCharge && siteInCharge.name}
                onChange={(value) => handleSiteFormInputChange('siteContactName', value)}
                errors={submitClicked || formTouched.siteContactName ? errors.siteContactName : []}
                required
                touched
                disabled={isDisabled()}
              />
            </div>
            <div className="flg-lg-6 flg-md-6 flg-sm-12">
              <Input
                type="text"
                label="Site Contact Number*"
                name="siteContactNumber"
                value={siteInCharge && siteInCharge.phoneNumber}
                onChange={(value) => value.length < 11 && handleSiteFormInputChange('siteContactNumber', value)}
                errors={submitClicked || formTouched.siteContactNumber ? errors.siteContactNumber : []}
                required
                touched
                disabled={isDisabled()}
              />
            </div>
            <div className="flg-lg-6 flg-md-6 flg-sm-12">
              <Input
                type="text"
                label="Site Contact Person Email*"
                name="siteContactEmail"
                value={siteInCharge && siteInCharge.email}
                onChange={(value) => handleSiteFormInputChange('siteContactEmail', value)}
                errors={submitClicked || formTouched.siteContactEmail ? errors.siteContactEmail : []}
                required
                touched
                disabled={isDisabled()}
              />
            </div>
          </div>
          {upgradeDetails.leadStatus === LEAD_STATUS.LEAD_IN_PROGRESS && isShiftingJourney() && (
            <Fragment>
              <div className="site-contact-installation-label">Installation Address</div>
              <div className="feasibility-requests home single-site-container feasibility-container shifting_feasibility_container">
                <DedicatedAccordionComponent
                  checkFeasibilityUpdate={(res) => console.log(res, '**res')}
                  isdedicatedJourney={true}
                  isUnAuthJourney={isUnAuthJourney}
                  productType={getProductType() ?? 'DEDICATED_INTERNET'}
                  selectedRadio={{ id: SINGLE_SITE }}
                  setToast={setToastMsg}
                  showAccordion={false}
                  onAddFeasibilitySuccess={(feasibilityResponse) => checkShiftingFeasibility(feasibilityResponse, true)}
                  showLastMileField={false}
                  showBandwidthField={false}
                  // showLatField={false}
                  // showLongField={false}
                  onSubmitCb={onSubmitCb}
                  cancelPnQLead={cancelPnQLead}
                  selectedBandwidth={selectedBandwidth && selectedBandwidth.key && parseInt(selectedBandwidth.key)}
                />
              </div>
            </Fragment>
          )}
          {/* {showFooter() && (
            <div className="action_button">
              <Button variant="outlinebtn" displayName="Cancel" onClick={onCancelClick} disabled={isCancelDisabled()}></Button>
              <Button displayName="Next" disabled={loading || isSubmitDisabled()} onClick={onSubmitClick}>
                {loading && <span className="loading_icon"></span>}
              </Button>
            </div>
          )} */}
        </div>
      </Accordion>
    </div>
  );
};

export default UpgradeOrderDetailsAccordion;
